module.exports = __webpack_public_path__ + "img/bg-2.bd39aa37.png";